import PostAsideSection from './PostAsideSection';
import {
  ArticleFragmentFragment,
  CategoryFragmentFragment,
  PostAsideContentFragmentFragment,
} from '../../__generated__/graphql';
import NewsletterSignupCard from '../../content-blocks/NewsletterSignup/NewsletterSignupCard';
import ArticleCard from '../ArticleCard';
import { TextLink } from '../Text';

import style from './post-aside.module.css';

interface PostAsideProps {
  categories: CategoryFragmentFragment[];
  className?: string;
  currentPostId: string;
  postAsideContent: null | PostAsideContentFragmentFragment;
  relatedPosts: ArticleFragmentFragment[];
}

const PostAside = ({
  categories,
  className,
  currentPostId,
  postAsideContent,
  relatedPosts,
}: PostAsideProps) => {
  const relatedPostsToShow = relatedPosts
    .filter(p => p.id !== currentPostId)
    .slice(0, 3);

  return (
    <aside className={className}>
      {!!relatedPostsToShow.length && (
        <PostAsideSection sectionTitle="Related Articles">
          <ul className={style.relatedArticlesList}>
            {relatedPostsToShow.map(article => {
              return (
                <ArticleCard
                  article={article}
                  articleLinkText=""
                  key={article.id}
                  size="small"
                />
              );
            })}
          </ul>
        </PostAsideSection>
      )}

      {!!categories.length && (
        <PostAsideSection sectionTitle="Browse Topics">
          <ul className={style.topicsList}>
            {categories.map(category => {
              return (
                <li key={category.name}>
                  <TextLink
                    fontSize={16}
                    linkFragment={{
                      title: category.name,
                      url: `/about-us/blog?categoryId=${category.databaseId.toString()}`,
                    }}
                  />
                </li>
              );
            })}
          </ul>
        </PostAsideSection>
      )}

      {postAsideContent?.newsletter && (
        <div className={style.newsLetterCard}>
          <NewsletterSignupCard
            darkBackground={false}
            description={postAsideContent.newsletter.description ?? ''}
            marketoFormId={postAsideContent.newsletter.marketoFormId}
            successMessage={postAsideContent.newsletter.successMessage ?? ''}
            title={postAsideContent.newsletter.title ?? ''}
            withSmallTitle
          />
        </div>
      )}
    </aside>
  );
};

export default PostAside;
